import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    CAMPAIGN_TYPES_ORDER,
    getDescriptionForCampaignType,
    getIconNameForCampaignType,
    getTitleForCampaignType,
    isBetaCampaignType
} from '../../service/CampaignHelpers/CampaignHelpers';
import { UrlHelpers } from '../../service/UrlHelpers';
import { LinkTarget } from '../../typings/common';
import { CampaignType } from '../../typings/domain';
import { BetaMark } from '../BetaMark/BetaMark';
import { Shape2, Shape2Theme } from '../Shape2/Shape2';

import './CampaignTypesList.css';

interface CampaignTypesListProps {
    availableCampaignTypes: CampaignType[];
    onClick: (type: CampaignType, linkTarget: LinkTarget) => void;
}

export class CampaignTypesList extends React.PureComponent<CampaignTypesListProps> {
    render() {
        const { availableCampaignTypes } = this.props;

        return (
            <div className={Bem.cls('campaign-types-list')}>
                {CAMPAIGN_TYPES_ORDER.filter(type => availableCampaignTypes.includes(type)).map(
                    this.getCampaignTypeItem
                )}
            </div>
        );
    }

    private onItemClick = (type: CampaignType) => (e: React.MouseEvent<HTMLElement>) => {
        const target = UrlHelpers.getLinkTarget(e);
        this.props.onClick(type, target);
    };

    private getCampaignTypeItem = (type: CampaignType) => {
        const title = getTitleForCampaignType(type);
        const icon = getIconNameForCampaignType(type);
        const description = getDescriptionForCampaignType(type);

        const betaMark = isBetaCampaignType(type) ? <BetaMark /> : undefined;

        return (
            <div
                key={type}
                className={classNames(
                    Bem.cls('campaign-types-list', 'item'),
                    Bem.cls('campaign-types-list', Bem.beminize(type))
                )}
                onClick={this.onItemClick(type)}
            >
                <Shape2
                    cls={Bem.cls('campaign-types-list', 'icon')}
                    theme={Shape2Theme.light}
                    icon={icon}
                    width={16}
                    height={16}
                />

                <div className={Bem.cls('campaign-types-list', 'item-content')}>
                    <div className={Bem.cls('campaign-types-list', 'item-title')}>
                        {title} {betaMark}
                    </div>
                    <div className={Bem.cls('campaign-types-list__item-body')}>{description}</div>
                </div>
            </div>
        );
    };
}
